import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';

export const AlertGroupedReportModule = new Module({
  id: 'report-alert-vehicle-categorization',
  name: 'Alerts Grouped Report',
  path: 'alert-grouped',
  Component: ComponentLoader(lazy(() => import('src/content/reports/Alert'))),
  actions: {
    details: {
      id: 'alert-grouped-details',
      name: 'alert-grouped-details',
      label: 'Details'
    }
  }
});
